import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-363d983c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "item-expansion" }),
    /*#__PURE__*/_createElementVNode("th", { class: "item-floc" }, "Functional Location"),
    /*#__PURE__*/_createElementVNode("th", { class: "item-floc-desc" }, "Func. Loc. Description"),
    /*#__PURE__*/_createElementVNode("th", { class: "item-is-asset" }, "Is Asset"),
    /*#__PURE__*/_createElementVNode("th", { class: "item-asset-class" }, "Asset Class"),
    /*#__PURE__*/_createElementVNode("th", { class: "item-actions" })
  ])
], -1))

import { FunctionalLocation } from "@/classes";
import { setupApiQueue } from "@/components/base/api-queue";
import { TreeItem } from "./tree";
import FunctionalLocationRow from "./FunctionalLocationRow.vue";
import { setupWindowSize } from "@/components/base/tables/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionalLocationTree',
  props: {
    treeItems: {},
    maxHeight: {}
  },
  emits: ["view", "remove"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const { queueApiAction, loading } = setupApiQueue();

const getTreeChildren = async (item: TreeItem<FunctionalLocation>) => {
  queueApiAction(async () => {
    const parentId = item.item.id;
    const flocs = await FunctionalLocation.getTreeChildren({
      parent_id: parentId,
    });
    const children = flocs.map((floc) => {
      return {
        item: floc,
        expanded: false,
        children: null,
      } as TreeItem<FunctionalLocation>;
    });
    item.children = children;
  });
};

const expand = async (item: TreeItem<FunctionalLocation>) => {
  item.expanded = true;
  if (item.children === null) {
    item.children = getTreeChildren(item);
  }
};

const collapse = async (item: TreeItem<FunctionalLocation>) => {
  item.expanded = false;
};

const { windowSize, onResize } = setupWindowSize();

const findItem = (
  parent: TreeItem<FunctionalLocation> | null,
  items: TreeItem<FunctionalLocation>[],
  id: string,
): {
  parent: TreeItem<FunctionalLocation> | null;
  item: TreeItem<FunctionalLocation> | null;
} => {
  for (const item of items) {
    if (item.item.id === id) {
      return { parent, item };
    }
  }
  for (const item of items) {
    if (Array.isArray(item.children)) {
      const found = findItem(item, item.children, id);
      if (found) {
        return found;
      }
    }
  }
  return { parent: null, item: null };
};

const refresh = async (id: string | null) => {
  if (id !== null) {
    const { parent, item } = findItem(null, props.treeItems, id);
    if (item) {
      const childrenCount = item.item.metrics.children_count;
      await item.item.refresh();
      item.item.metrics.children_count = childrenCount;

      if (item.item.hide_from_tree_top) {
        if (parent) {
          //if (Array.isArray(parent.children)) {
          //  parent.children = parent.children.filter((c) => c !== item);
          //}
        } else {
          emit("remove", item);
        }
      }
    }
  }
};

__expose({ refresh });

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!
  const _directive_resize = _resolveDirective("resize")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_table, {
    density: "compact",
    "fixed-header": "",
    style: _normalizeStyle({ maxHeight: _ctx.maxHeight || undefined }),
    height: _ctx.maxHeight ? '' : _unref(windowSize).y - 64
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treeItems, (treeItem) => {
          return (_openBlock(), _createBlock(FunctionalLocationRow, {
            key: treeItem.item.id,
            "tree-item": treeItem,
            depth: 0,
            onExpand: expand,
            onCollapse: collapse,
            onView: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view', $event)))
          }, null, 8, ["tree-item"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["style", "height"])), [
    [_directive_resize, _unref(onResize)]
  ])
}
}

})